
import Header from '../components/Header'
import Breadcrumb from "../components/Breadcrumb";
import Footer from '../components/Footer';
const AboutUs = () => {
    return(
        <>
            <Header/>
            <Breadcrumb pageTitle="About" mid="About" breadcrumbName="About Us" />
            <div className="inner-page">
                    <div className='container'>
                        <div className='row'>
                            
                            <div className='col-lg-6 col-md-12 animateMe'  data-animation="fadeInLeft">
                                <img src="Images/about-img.png" className='img-fluid' />
                            </div>
                            <div className='col-lg-6 col-md-12 animateMe'  data-animation="fadeInRight">
                                <p><span>ST. Thomas Sr. Sec. School, Civil Lines, Mainpuri </span>is a Catholic Christian, Minority educational institution, which was started in 1976 imparting education to all students irrespective of their sex, caste, creed and religion to strengthen inter religious, communal, cultural and social ties among the students, so that they learn to respect all religions and cultures in our country and strive to maintain unity in diversity as part of the God"s plan for ... Lush-green trees, resplendent flowers and extensive farmlands around offer it an idyllic setting and pollution-free environment. It is an institution where learning is a pleasurable pursuit, where hours spent happily in the playground give strength.</p>
                                
                            </div>
                        </div>
                    </div>
                </div>
            <Footer />
        </>
    )
}
export default AboutUs